/* eslint-disable */
class OsmMapHelper {
  getTile(position, zoomlevel) {
    return this.lonlatToTile(position.lon, position.lat, zoomlevel);
  }

  //get tile from lat & long
  lonlatToTile(lon, lat, zoomlevel) {
    let numOfTiles = Math.pow(2, zoomlevel);
    let lonDegreesPerTile = 360 / numOfTiles;
    let sinLat = Math.sin((lat * Math.PI) / 180);

    let tx = (lon + 180) / lonDegreesPerTile;
    let ty =
      (0.5 + (-0.5 * Math.log((1 + sinLat) / (1 - sinLat))) / (2 * Math.PI)) *
      numOfTiles;

    return [Math.floor(tx), Math.floor(ty)];
  }

  //get range from tile
  tileToBoundary(x, y, zoomlevel) {
    let p1 = this.tileToLonlat(x, y, zoomlevel);

    let p3 = this.tileToLonlat(x - 125, y - 125, zoomlevel);
    let p2 = this.tileToLonlat(x + 125, y + 125, zoomlevel);

    return {
      n: p3[1],
      w: p3[0],
      s: p2[1],
      e: p2[0]
    };

    /*    return {
      n: p1[1],
      w: p1[0],
      s: p2[1],
      e: p2[0]
    };*/
  }

  //get lat & long from tile
  tileToLonlat(tx, ty, zoomlevel) {
    let numOfTiles = Math.pow(2, zoomlevel);
    let x = tx / numOfTiles;
    let y = ty / numOfTiles;

    let lon = (x - 1 / 2) / (1 / 360);
    let latRadians = (y - 1 / 2) / -(1 / (2 * Math.PI));
    let lat =
      ((2 * Math.atan(Math.exp(latRadians)) - Math.PI / 2) / Math.PI) * 180;

    return [lon, lat];
  }

  getMapSize(boundary, size) {
    let width = boundary.e * size - boundary.w * size;
    let height = boundary.n * size - boundary.s * size;

    return {
      width: width,
      height: height
    };
  }

  getPoints(acc, item, position, size, boundary) {
    let points = [];

    Object.keys(item.nodes).forEach(nodeNumber => {
      let node = item.nodes[nodeNumber];
      let nodeData = acc.node[node];

      if (nodeData) {
        let lat = nodeData.lat;
        let lon = nodeData.lon;

        if (this.checkPoint(lon, lat, boundary)) {
          let x = lon * size - position.lon * size;
          let z = lat * size - position.lat * size;
          points.push(new BABYLON.Vector3(x, 0, z));
        }
      }
    });

    return points;
  }

  checkPoint(lon, lat, boundary) {
    let cx = (boundary.w - boundary.e) / 2 + boundary.e;
    let cz = (boundary.s - boundary.n) / 2 + boundary.n;

    let radius =
      Math.pow((boundary.w - boundary.e) / 2, 2) +
      Math.pow((boundary.s - boundary.n) / 2, 2);

    radius = radius / 2;

    let distance = Math.pow(lon - cx, 2) + Math.pow(lat - cz, 2);

    if (distance < radius) return true;
    else return false;
  }
}
export default new OsmMapHelper();

/* if (lon > boundary.e) lon = boundary.e;
        else if (lon < boundary.w) lon = boundary.w;

        if (lat > boundary.n) lat = boundary.n;
        else if (lat < boundary.s) lat = boundary.s;*/

//  if (lon > boundary.e || lon < boundary.w) return;
//  if (lat > boundary.n || lat < boundary.s) return;
